import { SportData } from '@/types/sports.model';
import { SPORT_DATA_FIELDS } from './sport-fields.config';
import { createApiWithFields } from '@/lib/api-base';

export const getSportsData = createApiWithFields<
  SportData,
  typeof SPORT_DATA_FIELDS
>('/sports', SPORT_DATA_FIELDS);
